const getters = {
  freeNum: state => state.user.freeNum,
  userInfo: state => state.user.userInfo,
  // token: state => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name
}
export default getters
